<template>
  <div>
      <div class="footerColor">
        <div class="footerInfo">
            <div>
                <span class="title">{{$t('服务范围')}} / Service Area</span>
                <div>
                    <img :src="require('../../assets/map-pic.png')" alt="">
                </div>
            </div>
            <div>
                <span class="title">{{$t('联系我们')}} / Contact Us</span>
                <div class="info">
                    <span><a-icon type="phone"  :rotate="180" class="mr18" />023-68631081</span>
                    <span><a-icon type="wechat"  class="mr18"/>DBM68631081 </span>
                    <span><a-icon type="qq"  class="mr18"/>2604256428</span>
                </div>
                <div class="DescriptionText">
                    <p>{{$t('客服工作时间')}}：09:00 - 22:00</p>
                    <p>{{$t('非工作时间我们不能及时回复您的信息，请在站内信留')}}<br>{{$t('下问题或留下您的联系方式我们将在第一时间联系到您')}}</p>
                </div>
            </div>
            <div >
                <span class="title">{{$t('新媒体')}} / New Media</span>
                <div class="qrcodeBox">
                    <div class="qrcode">
                        <img src="../../assets/MiniProgram.jpg">
                        <span>{{$t('道吧小程序')}}</span>
                    </div>
                    <div class="qrcode">
                        <img src="../../assets/OfficialAccount.jpg">
                        <span>{{$t('道吧公众号')}}</span>
                    </div>
                </div>
            </div>
        </div>

      </div>
       <div class="footerToolbarColor">
            <div class="footerToolbar">
                 <a href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">渝ICP备18013677号-1</a>
              <img :src="pliceIcon" style="margin-left: 20px"/>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer">渝公网安备 50010702503473号</a>
              <a href=" " target="_blank" style="position: relative;display: inline-block;height: 20px;">
                <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
                <embed width="0" height="0" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
                </a>
            </div>
            <div class="toTop" @click="toTop">
                <span>
                    返回顶部
                </span>
            </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  mounted () {},
  data () {
    return {
      title: 'footer',
      pliceIcon: require('@daoba-match/assets/pliceIcon.png')
    }
  },
  created () {},
  methods: {
    toTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.footerInfo{
   width: 1200px;
   margin: 0 auto;
   padding: 20px 0;
   display: flex;
   justify-content:space-between;

   color: #fff;
   .title{
       font-size: 20px;
       font-weight: 600;
   }
   div{
       .qrcodeBox{
           margin-top: 60px;
       }
       .qrcode{
           display: inline-block;
           margin-right:25px;
           position: relative;
           img{
               width: 120px;
               height: 120px;

           }
           span{
               display: block;
           }

       }
       .info{
           margin-top: 50px;

            span{
                display: block;
                font-size: 20px;
                margin: 8px 0;
                font-weight: 600;
            }
       }
       .DescriptionText{
           margin-top: 40px;
       }
   }
}
.footerToolbar{
   text-align: center;
   width: 1200px;
   margin: 0 auto;
   color: #fff;
   height: 41px;
   line-height: 41px;
   a{
       color: #fff;

   }
}
.footerColor{
    background-color: #000;
}

.footerToolbarColor{
    position: relative;
    background-color: rgb(184,0,0);
    .toTop{
        position: absolute;
        width: 160px;
        height: 41px;
        background-color: #000;
        right: 0;
        display: inline-block;
        top: 0;
        -webkit-clip-path: polygon(100% 0, 100% 100%, 0% 100%, 20% 0);
        clip-path: polygon(100% 0, 100% 100%, 0% 100%, 20% 0);
        text-align: center;
        cursor: pointer;
        span{
            font-size: 18px;
            font-weight: 600;
            color: #fff;
            line-height: 41px;
        }
    }
}
.width-main{
    width: 1200px;
    margin: 0 auto;
}
.bg{
    background-color: rgb(247,247,247);
}
.mr18{
    margin-right: 18px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/Footer.vue